<template>
    <div class="portfolio-section">  
        <PortfolioItem :items="item"></PortfolioItem>

        <section class="section-last portfolio-box">
            <h2 class="thin">Découvrez également</h2>
            <PortfolioGrid :portfolio=4 :remove=[13] :light=true></PortfolioGrid>
        </section>
    </div>
</template>

<script>

import PortfolioItem from './../../layout/PortfolioItem'
import PortfolioGrid from './../../layout/PortfolioGrid'

export default {
    components : {
        PortfolioItem,
        PortfolioGrid
    },
    data() {
        return {
            item : ['synchro']
        }
    }
}
</script>

<style scoped>
    .portfolio-section {
        display:flex;
        flex-direction: column;
    }

    .portfolio-box {
        max-width:1200px;
        margin:40px auto;
    }

    .portfolio-box h2 {
        font-size:30px;
        text-transform: uppercase;
    }

</style>